import { BaseCRUD } from '@/services/base-request';
import { toastError } from '@/composables/toast';

const serviceName = 'i18n';

export class LocalizationService {
    /**
     * @param {number} offset
     * @param {number} limit
     * @returns {Promise<Response>}
     */
    static async getLanguagesList (offset, limit) {
        const resp = await BaseCRUD.GET({
            service: serviceName,
            entity: `languages`,
            query: {
                offset,
                limit,
            },
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        return resp.payload;
    };

    /**
     * @param {string} id
     * @returns {Promise<Response>}
     */
    static async getCategoryTranslateById (id) {
        const resp = await BaseCRUD.GET({
            service: serviceName,
            entity: `translations/categories/${id}`,
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        return resp.payload;
    };

    /**
     * @param {string} id
     * @param {object} body
     * @param {string} body.name
     * @param {string} body.languageCode
     * @returns {Promise<Response>}
     */
    static async addTranslationForCategory (id, body) {
        const resp = await BaseCRUD.POST({
            service: serviceName,
            entity: `translations/categories/${id}`,
            body,
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        return resp.status.ok;
    }

    /**
     * @param {string} id
     * @returns {Promise<Response>}
     */
    static async getTagTranslateById (id) {
        const resp = await BaseCRUD.GET({
            service: serviceName,
            entity: `translations/tags/${id}`,
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        return resp.payload;
    };

    /**
     * @param {string} id
     * @param {object} body
     * @param {string} body.name
     * @param {string} body.languageCode
     * @returns {Promise<Response>}
     */
    static async addTranslationForTag (id, body) {
        const resp = await BaseCRUD.POST({
            service: serviceName,
            entity: `translations/tags/${id}`,
            body,
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        return resp.status.ok;
    };

    /**
     * @param {string} id
     * @returns {Promise<Response>}
     */
    static async getMainPromoTranslateById (id) {
        const resp = await BaseCRUD.GET({
            service: serviceName,
            entity: `translations/mainPromo/${id}`,
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        return resp.payload;
    };

    /**
     * @param {string} id
     * @param {object} body
     * @param {string} body.name
     * @param {string} body.languageCode
     * @returns {Promise<Response>}
     */
    static async addTranslationForMainPromo (id, body) {
        const resp = await BaseCRUD.POST({
            service: serviceName,
            entity: `translations/mainPromo/${id}`,
            body,
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        return resp.status.ok;
    };
}
